/**
 * Central configuration for the seven long-tail keyword landing pages.
 *
 * Content lives in `keywordLandingConfig.json` so both this ES-module
 * consumer (React) and `prerender.js` (Node/CJS) share ONE source of truth.
 * Add or edit a page in the JSON — routes, sitemap, and prerender pick
 * it up automatically.
 */
import KEYWORD_LANDING_JSON from "./keywordLandingConfig.json";

export const KEYWORD_LANDING_PAGES = KEYWORD_LANDING_JSON;

/**
 * Slugify a state name → "New York" → "new-york".
 */
export function stateNameToSlug(name) {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

/**
 * Build the display "in {State}" suffix used across meta tags and headlines.
 * Returns empty string for the national variant so copy reads naturally.
 */
export function stateLine(stateName) {
  return stateName ? `in ${stateName}` : "";
}

export const KEYWORD_SLUGS = Object.keys(KEYWORD_LANDING_PAGES);
